export const CF_CONTENT = {
  hero: {
    kicker: 'Para donos de empresa e responsáveis financeiros',
    title: 'Sua empresa fatura bem. Mas sobra dinheiro de verdade no fim do mês?',
    subtitle:
      'Tenha contas a pagar e receber organizadas por centro de custo, conciliação bancária automática via OFX e um DRE gerado sozinho, por período e por centro de custo. Chega de descobrir o resultado tarde demais.',
    cta: 'Quero ver o lucro real da empresa',
    ctaMessage: 'Quero conhecer o sistema de fluxo de caixa e DRE do 77Gestão',
    urgency: 'Toda decisão tomada sem DRE atualizado é uma aposta — não uma gestão.',
  },

  statsStrip: [
    { number: 'Automático', label: 'DRE por período e centro de custo', icon: 'fa-solid fa-chart-pie' },
    { number: 'Sem digitar', label: 'conciliação bancária via OFX', icon: 'fa-solid fa-file-arrow-up' },
    { number: 'Sua escolha', label: 'regime de competência ou caixa', icon: 'fa-solid fa-sliders' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações? Então a empresa está sendo gerida no escuro.',
    intro:
      'Empresas saudáveis tomam decisões erradas todos os dias porque o financeiro chega tarde, incompleto ou só no fim do mês. Não é falta de esforço — é falta de um sistema que organize isso de verdade.',
    items: [
      { icon: 'fa-solid fa-money-bill-wave', text: 'Não saber se sobra dinheiro no fim do mês até fechar tudo na mão.' },
      { icon: 'fa-solid fa-dice', text: 'Decisão de contratar, comprar ou investir tomada no achismo, sem dado financeiro confiável.' },
      { icon: 'fa-solid fa-file-excel', text: 'DRE feito em planilha, sempre atrasado e sujeito a erro de fórmula.' },
      { icon: 'fa-solid fa-magnifying-glass', text: 'Conciliar o extrato do banco linha por linha, na mão, todo mês.' },
      { icon: 'fa-solid fa-layer-group', text: 'Custo lançado tudo junto, sem saber qual centro de custo, área ou projeto consome mais.' },
    ],
  },

  midCta: {
    text: 'E se o DRE do mês estivesse pronto assim que o mês fechasse, sem você montar planilha nenhuma?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema de fluxo de caixa e DRE do 77Gestão',
  },

  solution: {
    title: 'Financeiro organizado por centro de custo. DRE pronto sem planilha.',
    intro:
      'O módulo financeiro do 77Gestão foi desenhado para dar clareza real sobre o resultado da empresa — não mais uma planilha para você alimentar.',
    cards: [
      {
        icon: 'fa-solid fa-calendar-check',
        title: 'Contas a pagar e a receber por centro de custo',
        text: 'Cada lançamento organizado por centro de custo, para você saber exatamente onde o dinheiro entra e sai.',
      },
      {
        icon: 'fa-solid fa-percent',
        title: 'Rateio entre centros de custo',
        text: 'Divida uma despesa entre mais de uma área, projeto ou filial, sem precisar duplicar lançamento.',
      },
      {
        icon: 'fa-solid fa-file-arrow-up',
        title: 'Conciliação bancária automática via OFX',
        text: 'Importe o arquivo OFX do banco e o sistema classifica automaticamente cada lançamento por categoria.',
      },
      {
        icon: 'fa-solid fa-chart-pie',
        title: 'DRE automático por período e centro de custo',
        text: 'Veja o resultado da empresa, de uma área ou de um período específico, gerado automaticamente pelo sistema.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Regime de competência ou caixa',
        text: 'Escolha como a empresa enxerga o resultado financeiro, conforme a necessidade de gestão ou do contador.',
      },
    ],
  },

  proof: {
    title: 'O que acontece quando o DRE para de depender de planilha',
    intro:
      'Uma empresa com faturamento relevante fechava o DRE em planilha, com quase duas semanas de atraso em relação ao fim do mês — e o sócio só descobria o resultado real quando já não dava mais para agir.',
    stats: [
      { number: '0', label: 'planilhas para montar o DRE' },
      { number: 'Diário', label: 'acompanhamento do fluxo de caixa' },
      { number: 'Por área', label: 'visibilidade de custo e resultado' },
    ],
    paragraphs: [
      'Depois da implantação, o DRE passou a ser gerado automaticamente por período e por centro de custo, com a conciliação bancária feita via importação do arquivo OFX.',
      'O sócio passou a acompanhar o resultado da empresa a qualquer momento, por área e por período, em vez de esperar o fechamento manual do mês para saber se sobrou ou faltou dinheiro.',
    ],
    highlight: 'Resultado: decisão com base em número real, DRE pronto sem planilha e visibilidade de onde o dinheiro realmente vai.',
    cta: 'Quero esse nível de clareza',
    ctaMessage: 'Vi o resultado e quero entender como ter DRE automático no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares de uma gestão financeira com dado real',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Saldo, fluxo de caixa e resultado por centro de custo disponíveis a qualquer momento, não só no fechamento.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Cada despesa e receita categorizada e rateada corretamente entre centros de custo.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'DRE e fluxo de caixa atualizados para decidir com dado, antes que o problema apareça no saldo.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o 77Gestão para controlar caixa e DRE',
    items: [
      { icon: 'fa-solid fa-file-arrow-up', text: 'Conciliação bancária automática via arquivo OFX, com classificação automática de categoria.' },
      { icon: 'fa-solid fa-chart-pie', text: 'DRE automático por período e centro de custo, sem depender de planilha ou de fechamento manual.' },
      { icon: 'fa-solid fa-layer-group', text: 'Financeiro integrado com vendas, estoque e nota fiscal — um lançamento alimenta tudo.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: seus centros de custo e regime financeiro são configurados junto com você.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano e próximo, sem ticket de fila para resolver uma dúvida no financeiro.' },
    ],
  },

  faq: {
    title: 'Dúvidas antes de organizar seu fluxo de caixa e DRE',
    items: [
      {
        question: 'Preciso conciliar o extrato do banco manualmente?',
        answer:
          'Não. Você importa o arquivo OFX exportado do seu banco e o sistema classifica automaticamente cada lançamento por categoria, restando só a conferência final.',
      },
      {
        question: 'O DRE separa o resultado por centro de custo automaticamente?',
        answer:
          'Sim. Depois de cadastrar os centros de custo e ratear os lançamentos, o DRE é gerado automaticamente por período e por centro de custo, sem montagem manual.',
      },
      {
        question: 'Funciona com regime de caixa ou só competência?',
        answer:
          'Funciona com os dois. Você escolhe se o resultado é apresentado por regime de competência ou de caixa, conforme a necessidade da gestão ou orientação do contador.',
      },
      {
        question: 'Meu contador pode usar os relatórios gerados pelo sistema?',
        answer:
          'Sim, o DRE e os relatórios financeiros gerados no sistema facilitam o trabalho do contador, servindo de base para o fechamento contábil.',
      },
      {
        question: 'Consigo ratear uma despesa entre mais de um centro de custo?',
        answer:
          'Sim, o rateio financeiro permite dividir um único lançamento entre vários centros de custo, sem precisar duplicar a conta.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de descobrir o resultado da empresa só no fim do mês.',
    subtitle:
      'Agende uma demonstração gratuita e veja como ter fluxo de caixa em tempo real e DRE automático por centro de custo, sem depender de planilha.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema de fluxo de caixa e DRE do 77Gestão',
  },

  seo: {
    title: 'Sistema de Fluxo de Caixa e DRE Automático | 77Gestão',
    description:
      'Sistema de fluxo de caixa com conciliação bancária via OFX e DRE automático por período e centro de custo, no regime de competência ou de caixa.',
  },
};
